import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import React, { Component } from "react";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
// import DatePicker from 'react-datepicker2';
// import moment from 'moment-jalaali'
// import NumberFormat from 'react-number-format';
// import ToggleButton from '../components/ToggleButton'
import { Redirect } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
// import dateicon from '../assets/dateicon.png'
import { toast } from "react-toastify";
import axios from "axios";
// import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";
import dateicon from "../assets/dateicon.png";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

export default class ImportExcel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBasket: "",
      selectedBroker: "",
      basketValue: "",
      brokerValue: "",
      Redirect: false,
      dateErrorText: "",
      cashErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      appErrorText: "",
      fileErrorText: "",
      basketFalse: false,
      brokerFalse: false,
      fileFalse: false,
      appFalse: false,
      buttonDisabled: false,
      fileName: "فایل انتخاب نشده است",
      selectedFile: null,
      uploadButtonText: "ثبت",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      dateFalse: false,
      portfolioCheck: true,
      AppData: [{ id: 1, name: "Easy Trader" }],
    };

    this.SubmitFrom = this.SubmitFrom.bind(this);
    this.setBrokersData = this.setBrokersData.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.radioPortfolioChange = this.radioPortfolioChange.bind(this);
    this.radioTurnoverChange = this.radioTurnoverChange.bind(this);

    this.uploadCatalog = this.uploadCatalog.bind(this);
    this.inputFile = React.createRef();
    this.radioPortfolio = React.createRef();

    this.fields1 = { value: "lable" };
    this.fields2 = { value: "full_name" };
    this.fields3 = { value: "name" };

    this.datepickerr = React.createRef();
  }

  componentDidMount() {
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length < 2
    ) {
      this.setBrokerValue(this.props.userBrokersData[0].full_name, true);
    }

    if (this.props.userBasketsData.length < 2) {
      this.setBasketValue(this.props.userBasketsData[0].lable, true);
    }
  }

  setBrokersData(data) {
    this.setState({ brokersData: data });
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  SubmitFrom() {
    try {
      let selectbasket = this.acBaskets.value;
      let selectbroker = this.acBrokers.value;
      let selectapp = "";
      let brokerid;
      let basketid;
      // let date=this.convertDate(this.state.dateValue);
      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      if (!this.state.portfolioCheck) {
        selectapp = this.acApp.value;
      }

      this.props.userBasketsData.forEach(function (entry) {
        if (entry.lable === selectbasket) {
          basketid = entry.id;
        }
      });

      this.props.userBrokersData.forEach(function (entry) {
        if (entry.full_name === selectbroker) {
          brokerid = entry.id;
        }
      });

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      if (
        !this.state.portfolioCheck &&
        (selectapp === null || selectapp === "" || selectapp === undefined)
      ) {
        this.setState({
          appFalse: true,
          appErrorText: "نرم افزار مورد نظر را مشخص کنید",
        });
        return;
      } else {
        this.setState({ appFalse: false, appErrorText: "" });
      }
      if (
        this.acBaskets.value === null ||
        this.acBaskets.value === "" ||
        basketid === undefined
      ) {
        this.setState({
          basketFalse: true,
          basketErrorText: "نام سبد نامعتبر است",
        });
        return;
      } else {
        this.setState({ basketFalse: false, basketErrorText: "" });
      }
      if (
        this.acBrokers.value === null ||
        this.acBrokers.value === "" ||
        brokerid === undefined
      ) {
        this.setState({
          brokerFalse: true,
          brokerErrorText: "نام کارگزاری نامعتبر است",
        });
        return;
      } else {
        this.setState({ brokerFalse: false, brokerErrorText: "" });
      }

      // this.setState({actionError:''})
      if (this.state.selectedFile !== null) {
        let data = new FormData();
        data.append("file", this.state.selectedFile);
        if (this.state.portfolioCheck) {
          data.append("type", "portfolio");
        } else {
          data.append("type", "transaction");
          data.append("application", selectapp);
        }
        data.append("basket_id", Number(basketid));
        data.append("broker_id", Number(brokerid));
        data.append("date", date);
        this.setState({
          uploadButtonText: "درحال بارگذاری ...",
          uploadButtonDisable: true,
        });
        axios
          .post("/api/uploadfile", data)
          .then((res) => {
            // console.log(res);
            if (res.data.status === 200) {
              this.setState(
                { uploadButtonText: "ثبت", uploadButtonDisable: false },
                () => {
                  this.resetForm();
                }
              );
              this.props.onRefresh();

              toast.success("فایل با موفقیت بارگذاری شد", {
                position: toast.POSITION.BOTTOM_LEFT,
                hideProgressBar: true,
                autoClose: 8000,
                toastClassName: "toast",
              });

              if (
                res.data.description !== undefined &&
                res.data.description !== null &&
                res.data.description !== ""
              ) {
                toast.success(res.data.description, {
                  position: toast.POSITION.BOTTOM_LEFT,
                  hideProgressBar: true,
                  autoClose: 8000,
                  toastClassName: "toast",
                });
              }
            } else {
              toast.error(res.data.message, {
                position: toast.POSITION.BOTTOM_LEFT,
                hideProgressBar: true,
                autoClose: 8000,
                toastClassName: "toast",
              });
              this.setState({
                uploadButtonText: "ثبت",
                uploadButtonDisable: false,
              });
            }
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            this.setState({
              uploadButtonText: "ثبت",
              uploadButtonDisable: false,
            });
          });
      } else {
        this.setState({
          fileErrorText: "مشکل در بارگذاری فایل",
          uploadButtonText: "ثبت",
          uploadButtonDisable: false,
        });
      }
    } catch (error) {
      this.setState({ uploadButtonText: "ثبت", uploadButtonDisable: false });
    }
  }

  setBasketValue(name, readonly) {
    this.acBaskets.value = name;
    this.acBaskets.readonly = readonly;
  }

  setBrokerValue(name, readonly) {
    this.acBrokers.value = name;
    this.acBrokers.readonly = readonly;
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    if (!this.state.uploadButtonDisable) {
      // this.setState({
      // basketErrorText:'',
      // brokerErrorText:'',
      // dateErrorText:'',
      // basketFalse:false,
      // brokerFalse:false,
      // dateFalse:false,
      // fileName:'فایل انتخاب نشده است',
      // selectedFile:null});

      this.setState({
        selectedBasket: "",
        selectedBroker: "",
        basketValue: "",
        brokerValue: "",
        Redirect: false,
        dateErrorText: "",
        cashErrorText: "",
        basketErrorText: "",
        brokerErrorText: "",
        appErrorText: "",
        fileErrorText: "",
        basketFalse: false,
        brokerFalse: false,
        fileFalse: false,
        appFalse: false,
        buttonDisabled: false,
        fileName: "فایل انتخاب نشده است",
        selectedFile: null,
        dateFalse: false,
      });

      if (
        this.props.selectedPortfolioId === 0 &&
        this.props.userBasketsData.length > 1
      ) {
        this.acBaskets.value = null;
      }
      if (
        this.props.selectedBrokerId === 0 &&
        this.props.userBrokersData.length > 1
      ) {
        this.acBrokers.value = null;
      }
    }
  }

  uploadCatalog(event) {
    try {
      if (event.target.files[0] !== undefined) {
        this.setState({
          fileName: event.target.files[0].name,
          selectedFile: event.target.files[0],
        });
      } else {
        this.setState({ fileName: "فایل انتخاب نشده است", selectedFile: null });
      }
    } catch (error) {
      // this.setState({buttonDisabled:false})
    }
    // console.log(event.target.files[0].name)
    // console.log(event.target.files[0].type)
    // return;
  }

  openFileDialog() {
    this.inputFile.current.click();
  }

  itemTemplate(data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>{data.broker_name}</div>
        {data.lable !== null &&
          data.lable !== "" &&
          data.lable !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--gray1)" }}>
              {data.lable}
            </div>
          )}
      </div>
    );
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue: value });
  }

  radioPortfolioChange(e) {
    // console.log(e);
    this.setState({ portfolioCheck: true }, () => {
      this.resetForm();
    });
    // if (this.radioPortfolio.checked){
    //     this.setState({portfolioCheck: true});
    // }
  }

  radioTurnoverChange(e) {
    // console.log(e);
    this.setState({ portfolioCheck: false }, () => {
      this.resetForm();
    });
    // if (!this.radioPortfolio.checked){
    //     this.setState({portfolioCheck: false});
    // }
  }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    return (
      <div className="contentStyle">
        <div id="componentsParent" style={{ minHeight: "450px" }}>
          <input
            type="file"
            ref={this.inputFile}
            onChange={this.uploadCatalog}
            accept=".xlsx,.xls"
            style={{ display: "none" }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "10px",
              marginBottom: "15px",
            }}
          >
            <RadioButtonComponent
              label="پرتفوی"
              ref={this.radioPortfolio}
              change={this.radioPortfolioChange}
              enableRtl="true"
              name="type"
              checked={true}
            />
            <div style={{ width: "50px" }} />
            <RadioButtonComponent
              label="گردش حساب"
              enableRtl="true"
              name="type"
              change={this.radioTurnoverChange}
            />
          </div>
          {this.state.portfolioCheck && (
            <p className="pStyle">
              فایل اکسل نمونه را از{" "}
              <a
                className="linkStyle inline"
                href="/api/public/exampleFiles/BurcelExample.xlsx"
              >
                اینجا
              </a>{" "}
              دانلود کنید و سپس اطلاعات پرتفوی خود را در آن وارد کرده و آپلود
              فرمائید.{" "}
            </p>
          )}
          {!this.state.portfolioCheck && (
            <p className="pStyle">
              فایل اکسل خروجی نرم افزار مورد نظر را به همراه نام نرم افزار
              انتخاب کنید.{" "}
            </p>
          )}

          <div
            style={{
              width: "100%",
              height: "1px",
              backgroundColor: "var(--gray1)",
              margin: "5px 0px",
              opacity: "0.5",
            }}
          />
          {/* {this.state.portfolioCheck && <div style={{width:'100px',height:'20px',backgroundColor:'red'}} />} */}
          {this.state.portfolioCheck && (
            <div className="InputWithIcon" style={{ direction: "ltr" }}>
              <div className="inputImageDiv">
                <img src={dateicon} className="inputImage" alt="date" />
              </div>
              {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                            /> */}
              <DatePicker
                ref={this.datepickerr}
                value={this.state.dateValue}
                inputClass={
                  this.state.dateFalse
                    ? "form-control inputStyleRed"
                    : "form-control inputStyleForm"
                }
                calendar="persian"
                locale="fa"
                weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                format="YYYY/MM/DD"
                animation
                className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
                onChange={(valuee) => this.dateChange(valuee)}
                maxDate={this.state.maxDateStart}
                editable={false}
                inputMode="none"
                fixMainPosition={true}
                fixRelativePosition={true}
                placeholder="تاریخ"
              />
            </div>
          )}

          {this.state.portfolioCheck && (
            <div className="errorMessage1">{this.state.dateErrorText}</div>
          )}
          {!this.state.portfolioCheck && (
            <AutoCompleteComponent
              showPopupButton={true}
              className={
                this.state.appFalse ? "inputStyleRed" : "inputStyleForm"
              }
              allowCustom={true}
              ref={(scope) => (this.acApp = scope)}
              filterType="Contains"
              enableRtl="true"
              noRecordsTemplate="موردی یافت نشد"
              popupHeight="550px"
              dataSource={this.state.AppData}
              fields={this.fields3}
              placeholder="نرم افزار"
              autofill={true}
            />
          )}
          {!this.state.portfolioCheck && (
            <div className="errorMessage1">{this.state.appErrorText}</div>
          )}
          <div
            style={{
              width: "0px",
              height: "0px",
              backgroundColor: "transparent",
              opacity: "0",
              margin: "0",
            }}
          />
          <AutoCompleteComponent
            showPopupButton={true}
            className={
              this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
            }
            allowCustom={true}
            ref={(scope) => (this.acBaskets = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBasketsData}
            fields={this.fields1}
            placeholder="سبد"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.basketErrorText}</div>
          <AutoCompleteComponent
            showPopupButton={true}
            itemTemplate={this.itemTemplate}
            className={
              this.state.brokerFalse ? "inputStyleRed" : "inputStyleForm"
            }
            allowCustom={true}
            ref={(scope) => (this.acBrokers = scope)}
            filterType="Contains"
            enableRtl="true"
            noRecordsTemplate="موردی یافت نشد"
            popupHeight="550px"
            dataSource={this.props.userBrokersData}
            fields={this.fields2}
            placeholder="کارگزاری"
            autofill={true}
          />
          <div className="errorMessage1">{this.state.brokerErrorText}</div>
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <div className="pStyle" style={{ flex: "1", marginLeft: "10px" }}>
              {this.state.fileName}
            </div>
            <Button
              variant="secondary"
              className="uploadFormButtonStyle"
              onClick={this.openFileDialog.bind(this)}
            >
              <div>انتخاب فایل</div>
            </Button>
          </div>
          <div className="errorMessage1">{this.state.fileErrorText}</div>
          {!this.props.isPopup && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.uploadButtonDisable}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.uploadButtonDisable && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.uploadButtonDisable && (
                <div>{this.state.uploadButtonText}</div>
              )}
            </Button>
          )}
          {this.props.isPopup && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              <Button
                variant="secondary"
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                disabled={this.state.uploadButtonDisable}
                onClick={this.SubmitFrom.bind(this)}
              >
                {this.state.uploadButtonDisable && (
                  <Spinner className="spinnerStyle" animation="border" />
                )}
                {!this.state.uploadButtonDisable && (
                  <div>{this.state.uploadButtonText}</div>
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
